/**
 * Custom hooks for user preferences operations
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { preferencesService } from '../services/preferencesService';

/**
 * Hook to fetch current user preferences
 * @returns {Object} Query result with data, loading, and error states
 */
export function usePreferences() {
  return useQuery({
    queryKey: ['preferences'],
    queryFn: () => preferencesService.getPreferences()
  });
}

/**
 * Hook to create or update user preferences
 * @returns {Object} Mutation result with mutate function
 */
export function useUpdatePreferences() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: preferencesService.upsertPreferences,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['preferences'] });
    }
  });
}
